import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import Button from "@mui/material/Button";
import { getListingStatusMeta } from "utils/listingStatus";

export default function vehicleApprovalTableData({
  vehicleList = [],
  onView,
  onApprove,
  onReject,
  onRemove,
}) {
  return {
    columns: [
      { Header: "Vehicle", accessor: "vehicle", width: "30%", align: "left" },
      { Header: "Price", accessor: "price", align: "left" },
      { Header: "Seller", accessor: "seller", align: "left" },
      { Header: "Location", accessor: "location", align: "left" },
      { Header: "Submitted", accessor: "submittedAt", align: "left" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: vehicleList.map((vehicle) => ({
      // Not a column — carried through so DataTable's onRowClick can hand back the vehicle.
      rowData: vehicle,
      vehicle: (
        <MDBox display="flex" alignItems="center" gap={1}>
          <MDAvatar
            src={vehicle?.photos?.[0]}
            alt={vehicle?.title}
            size="lg"
            variant="rounded"
            imgProps={{ referrerPolicy: "no-referrer" }}
            sx={{ border: "1px solid", borderColor: "divider" }}
          />
          <MDTypography variant="button" fontWeight="medium">
            {vehicle?.title}
          </MDTypography>
        </MDBox>
      ),
      price: (
        <MDTypography variant="button" fontWeight="medium">
          {vehicle?.price}
        </MDTypography>
      ),
      seller: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {vehicle?.seller}
        </MDTypography>
      ),
      location: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {vehicle?.location}
        </MDTypography>
      ),
      submittedAt: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {vehicle?.submittedAt}
        </MDTypography>
      ),
      status: (
        <MDBox display="flex" flexDirection="column" alignItems="center" gap={0.5}>
          <MDBadge
            badgeContent={getListingStatusMeta(vehicle?.status).label}
            color={getListingStatusMeta(vehicle?.status).color}
            variant="gradient"
            size="sm"
          />
          {(vehicle?.status === "approved" ||
            vehicle?.status === "active" ||
            vehicle?.status === "rejected") &&
            vehicle?.updatedAt && (
              <MDTypography variant="caption" color="text" sx={{ fontSize: "0.65rem" }}>
                {vehicle.updatedAt}
              </MDTypography>
            )}
        </MDBox>
      ),
      actions: (
        // Stop clicks here from also triggering the row's view handler.
        <MDBox
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={1}
          onClick={(event) => event.stopPropagation()}
        >
          <Button size="small" onClick={() => onView(vehicle)}>
            View
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() => onApprove(vehicle?.id)}
            sx={{
              backgroundColor: "#2e7d32",
              color: "#fff",
              "&:hover": { backgroundColor: "#1b5e20" },
              "&.Mui-disabled": { backgroundColor: "rgba(46,125,50,0.4)", color: "#fff" },
            }}
          >
            Approve
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() => onReject(vehicle?.id)}
            sx={{
              backgroundColor: "#d32f2f",
              color: "#fff",
              "&:hover": { backgroundColor: "#9a0007" },
              "&.Mui-disabled": { backgroundColor: "rgba(211,47,47,0.4)", color: "#fff" },
            }}
          >
            Reject
          </Button>
          <Button
            size="small"
            variant="outlined"
            onClick={() => onRemove(vehicle?.id)}
            sx={{
              borderColor: "rgba(0,0,0,0.3)",
              color: "text.secondary",
              "&:hover": { borderColor: "rgba(0,0,0,0.5)" },
            }}
          >
            Deactivate
          </Button>
        </MDBox>
      ),
    })),
  };
}
